module.exports = __webpack_public_path__ + "img/icon_enterpriserealty_document_02.856608c7.svg";